import { Instagram, Facebook, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, LOGO_URL, NAV_LINKS } from "./constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--ab-bg-soft-2)] border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#anasayfa" className="flex items-center gap-2.5">
              <img
                src={LOGO_URL}
                alt="AjansBilir"
                className="h-12 w-12 object-contain rounded-md"
              />
              <div>
                <div className="font-display font-extrabold text-xl text-[var(--ab-navy)]">
                  Ajans<span className="text-[var(--ab-blue)]">Bilir</span>
                </div>
                <div className="text-[0.65rem] uppercase tracking-[0.18em] text-slate-500">
                  Dijital Çözümler
                </div>
              </div>
            </a>
            <p className="mt-5 text-slate-600 text-sm max-w-sm leading-relaxed">
              İşletmelerin dijital dünyada öne çıkması için web tasarımı,
              reklam yönetimi ve otomasyon hizmetleri sunuyoruz.
            </p>

            <div className="mt-6 flex items-center gap-2">
              <a
                href={CONTACT.social.instagram}
                aria-label="Instagram"
                data-testid="footer-social-instagram"
                className="w-10 h-10 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:bg-[var(--ab-blue)] hover:text-white hover:border-[var(--ab-blue)] transition-all"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={CONTACT.social.facebook}
                aria-label="Facebook"
                data-testid="footer-social-facebook"
                className="w-10 h-10 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:bg-[var(--ab-blue)] hover:text-white hover:border-[var(--ab-blue)] transition-all"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={CONTACT.social.linkedin}
                aria-label="LinkedIn"
                data-testid="footer-social-linkedin"
                className="w-10 h-10 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:bg-[var(--ab-blue)] hover:text-white hover:border-[var(--ab-blue)] transition-all"
              >
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
              Site Haritası
            </div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-link-${l.id}`}
                    className="text-sm text-slate-600 hover:text-[var(--ab-blue)] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
              İletişim
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={CONTACT.phoneLink}
                  className="flex items-start gap-2.5 text-slate-700 hover:text-[var(--ab-blue)] transition-colors"
                >
                  <Phone className="h-4 w-4 mt-0.5 shrink-0" />
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.emailLink}
                  className="flex items-start gap-2.5 text-slate-700 hover:text-[var(--ab-blue)] transition-colors"
                >
                  <Mail className="h-4 w-4 mt-0.5 shrink-0" />
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-slate-700">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                {CONTACT.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="ab-divider mt-12" />

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} AjansBilir. Tüm hakları saklıdır.
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-[var(--ab-blue)]">
              Gizlilik Politikası
            </a>
            <a href="#" className="hover:text-[var(--ab-blue)]">
              Kullanım Şartları
            </a>
            <a href="#" className="hover:text-[var(--ab-blue)]">
              KVKK
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
